import { Col, Row, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { get, post } from "../../../../helper/request";
import { renderApiDomain } from "../../../../helper/renderApiDomain";

const ItemSelect = styled.div`
  box-shadow: 0 0 7px #80808033;
  padding: 12px;
  cursor: pointer;
  border-radius: 3px;
  transition: all 0.3s;
  height: 100%;
  &:hover {
    background: #1f73b7;
    color: #fff;
  }
`;
export const postNowPayment = ({ amount_thb, account_trade_id }) => {
  return post(`${renderApiDomain() + "deposit/nowpayment"}`, {
    amount_thb: amount_thb,
    account_trade_id: account_trade_id,
  });
};

const NowPayment = (props) => {
  const selectIp = useSelector(({ user: { ipAddress } }) => ipAddress);

  const refPerfect = useRef(null);
  const [loading, setLoading] = useState(false);
  const [linkPay, setLinkPay] = useState(null);

  useEffect(() => {
    onFinish();
  }, []);
  const onFinish = async (el) => {
    try {
      setLoading(true);
      const payload = {
        account_trade_id: props.account.id,
        amount_thb: +props.amount,
      };
      const { data } = await postNowPayment(payload);

      if (data) {
        setLoading(true);

        await Promise.all([setLinkPay(data.data.link)]).then(() => {
          refPerfect.current.click();
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Spin spinning={loading}>
      <a ref={refPerfect} href={linkPay} hidden>
        NowPayment
      </a>
    </Spin>
  );
};

export default NowPayment;
